// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UvXxxo {
  display: flex;
  flex: 1;
  position: relative;
  z-index: 1000;
  min-height: 519px;
  justify-content: center;
  align-items: center;
}
.cAE2xV {
  border: none;
  padding: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  left: auto;
  width: 400px;
  height: 100vh;
  min-height: 100vh;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s) 0 0 var(--radius-s);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  cursor: default;
  z-index: 1300;
}

.cAE2xV:focus {
  outline: none;
}

.cAE2xV::backdrop {
  background: var(--neutral-dark-opacity-50);
}

.cAE2xV[open] {
  margin: 0;
  height: 100vh;
  min-height: 100vh;
}

._jASQz {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: var(--spacing-1);
  padding: var(--spacing-3) var(--spacing-3) 0 var(--spacing-3);
}

.KWono7 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.wf7oHX {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--text-neutral-dark);
}

.Yq5Gny {
  width: 16px;
  height: 16px;
}

.OsRLdY {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  background: var(--surface-neutral-white);
  padding: var(--spacing-3);
  gap: var(--spacing-3);
}

.yfLJto {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-1);
}

.k10_Bn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-1-5);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-style: var(--font-style-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-100);
  letter-spacing: var(--letter-spacing-0);
  vertical-align: var(--vertical-align-middle);
  color: var(--text-neutral-dark, #1f1f1f);
}

.LI3uFr {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.m5IAAk {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  margin-top: var(--spacing-3);
}

.PtQjG6 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: left;
}

.d5zA2P {
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
}

.Fsklq3 {
  position: relative;
  width: 100%;
}

.QluXrR {
  width: 100%;
  height: 1px;
  background-color: var(--ibk-colors-neutral-400, #e6e6e6);
  margin: 0;
  padding: 0;
}

.szwRFM {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.gNDhd9 {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--spacing-1-5, 12px);
}

.aNZEmJ {
  width: 50%;
}

.yjGWsT {
  width: 100% !important;
  height: var(--input-height, 40px) !important;
  border-radius: var(--radius-m, 4px);
}

.PWLwxS {
  width: 100% !important;
  height: var(--input-height, 40px) !important;
  border-radius: var(--radius-m, 4px);
  border: 1px solid transparent !important;
  background: transparent !important;
  font-size: var(--font-size-md, 14px) !important;
  color: var(--text-neutral-dark) !important;
  outline: none !important;
  transition: border 0.2s !important;
  font-family: var(--font-family-base) !important;
}

.PWLwxS:focus {
  border-color: var(--surface-primary-medium, #d64000) !important;
  outline-offset: var(--spacing-0, 0) !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/BankDetailsModal/BankDetailsModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,kDAAkD;EAClD,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;EACxC,sCAAsC;EACtC,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wDAAwD;EACxD,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,mCAAmC;EACnC,wCAAwC;EACxC,kCAAkC;EAClC,+CAA+C;EAC/C,0CAA0C;EAC1C,wBAAwB;EACxB,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,+DAA+D;EAC/D,8CAA8C;AAChD","sourcesContent":[".loader {\n  display: flex;\n  flex: 1;\n  position: relative;\n  z-index: 1000;\n  min-height: 519px;\n  justify-content: center;\n  align-items: center;\n}\n.modal {\n  border: none;\n  padding: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: auto;\n  width: 400px;\n  height: 100vh;\n  min-height: 100vh;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s) 0 0 var(--radius-s);\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  cursor: default;\n  z-index: 1300;\n}\n\n.modal:focus {\n  outline: none;\n}\n\n.modal::backdrop {\n  background: var(--neutral-dark-opacity-50);\n}\n\n.modal[open] {\n  margin: 0;\n  height: 100vh;\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-1);\n  padding: var(--spacing-3) var(--spacing-3) 0 var(--spacing-3);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: var(--text-neutral-dark);\n}\n\n.chevronLeft {\n  width: 16px;\n  height: 16px;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  width: 100%;\n  background: var(--surface-neutral-white);\n  padding: var(--spacing-3);\n  gap: var(--spacing-3);\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.rowAmount {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-1-5);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-style: var(--font-style-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-100);\n  letter-spacing: var(--letter-spacing-0);\n  vertical-align: var(--vertical-align-middle);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.row {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.rowRandom {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  margin-top: var(--spacing-3);\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.footer {\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n}\n\n.button {\n  position: relative;\n  width: 100%;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--ibk-colors-neutral-400, #e6e6e6);\n  margin: 0;\n  padding: 0;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.agencyAccountWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-1-5, 12px);\n}\n\n.agencyAccountField {\n  width: 50%;\n}\n\n.inputContainer {\n  width: 100% !important;\n  height: var(--input-height, 40px) !important;\n  border-radius: var(--radius-m, 4px);\n}\n\n.input {\n  width: 100% !important;\n  height: var(--input-height, 40px) !important;\n  border-radius: var(--radius-m, 4px);\n  border: 1px solid transparent !important;\n  background: transparent !important;\n  font-size: var(--font-size-md, 14px) !important;\n  color: var(--text-neutral-dark) !important;\n  outline: none !important;\n  transition: border 0.2s !important;\n  font-family: var(--font-family-base) !important;\n}\n\n.input:focus {\n  border-color: var(--surface-primary-medium, #d64000) !important;\n  outline-offset: var(--spacing-0, 0) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `UvXxxo`,
	"modal": `cAE2xV`,
	"header": `_jASQz`,
	"title": `KWono7`,
	"closeButton": `wf7oHX`,
	"chevronLeft": `Yq5Gny`,
	"body": `OsRLdY`,
	"column": `yfLJto`,
	"rowAmount": `k10_Bn`,
	"row": `LI3uFr`,
	"rowRandom": `m5IAAk`,
	"label": `PtQjG6`,
	"footer": `d5zA2P`,
	"button": `Fsklq3`,
	"divider": `QluXrR`,
	"inputWrapper": `szwRFM`,
	"agencyAccountWrapper": `gNDhd9`,
	"agencyAccountField": `aNZEmJ`,
	"inputContainer": `yjGWsT`,
	"input": `PWLwxS`
};
module.exports = ___CSS_LOADER_EXPORT___;
